import * as React from 'react';
import {Box, Card as MuiCard, CardContent, Stack, Divider, Avatar} from '@mui/material';
import { Card as ModelCard } from './models/Card';
import SubHeading from 'components/labels/SubHeading';
import Text from 'components/labels/Text';
import CheckIcon from '@mui/icons-material/Check';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Icon from 'components/icons/Icon';
import { ColorsUtil, MyTheme } from "MyTheme"
import Link from 'components/buttons/Link';
import { Testimonial } from './models/Testimonial';

export interface CardTestimonial{
    testimonial: Testimonial;
}
const CardTestimonial = (props: CardTestimonial) => {
    const {testimonial, ...rest} = props;
    const firm = testimonial.firm;

    return (
        <MuiCard sx={{height: '100%', display: 'flex', flex: '1 1 0', overflow: 'visible'}} {...rest}>
            <CardContent sx={{position: 'relative', overflow: 'visible', width: '100%'}}>
                <Stack height={'100%'} spacing={2} divider={<Divider/>} direction='column'>
 
                <Box display='flex' flex="1 1 0">
                    {/* <blockquote> */}
                    <Text fontStyle='italic' mt={1}>"{testimonial.quote}"</Text>

                    {/* </blockquote> */}
                </Box>

                <Box display='flex'>
                        <Stack alignItems={'center'} spacing={2} direction={'row'}>
                            <Avatar/>
                            <Stack spacing={0} direction={'column'}>
                                {/* <Icon small>account_balance</Icon> */}
                                <Text>{testimonial.fullname}</Text>
                                <Text>{testimonial.position}</Text>
                                <Stack spacing={1} direction='row'>
                                    <Text>{firm.name}</Text>
                                    {firm.website && <Link target="_blank" href={firm.website}>
                                        <Icon small>open_in_new</Icon>
                                    </Link>}
                                </Stack>
                            </Stack>
                        </Stack>

                </Box>
                </Stack>

            </CardContent>
        </MuiCard>
    ) 
}

export default CardTestimonial;